import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47e2fe00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col max-w-5xl" }
const _hoisted_2 = { class: "my-16 py-4 px-2 h-fit rounded-lg text-white text-base horizontal-gradient" }
const _hoisted_3 = { class: "px-4 w-full h-full flex justify-center items-center rounded text-white text-base horizontal-gradient" }
const _hoisted_4 = { class: "my-16 p-0.5 rounded text-base horizontal-gradient" }
const _hoisted_5 = { class: "h-full gradient-bg-color" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "flex justify-center" }

import { computed } from 'vue';
import { useMeta } from 'quasar';
import { useMetaStore } from 'stores/modules/meta';
import tmpl from 'src/utils/tmpl';
import { useI18n } from 'vue-i18n';


import { usePageStore } from 'stores/modules/page';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ id: currentRoute.params.id as string });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProductListPage',
  setup(__props) {

const { t } = useI18n();

const pageStore = usePageStore();
const page = computed(() => pageStore.page);

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);

const background = (image: string, size = 'cover') => {
  return image
    ? `background: url('${image}') no-repeat; background-size: ${size}; background-position: center center`
    : '';
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "w-full flex justify-center",
        style: _normalizeStyle(background(page.value.image))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((page.value.summary ?? '').split('\n'), (p, i) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "text-center",
                key: i
              }, _toDisplayString(p), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.regions, (region) => {
            return (_openBlock(), _createElementBlock("div", {
              key: region.id,
              class: "grid grid-cols-2 gap-32"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: child.id,
                  class: "h-full"
                }, [
                  _createVNode(_component_q_btn, {
                    class: "w-full h-11",
                    "no-caps": "",
                    square: "",
                    padding: "0",
                    to: _unref(tmpl)(child.url, child)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(child.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "p-4",
                        innerHTML: child.summary,
                        style: {"min-height":"128px"}
                      }, null, 8, _hoisted_6),
                      (child.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: child.image,
                            alt: child.name
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_btn, {
              class: "px-10 mb-16 w-40 text-base text-white horizontal-gradient",
              flat: "",
              "no-caps": "",
              href: "/about/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Product.consult')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 4)
    ]),
    _: 1
  }))
}
}

})